/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateNewsDto } from '../../models/lexplus-create-news-dto';
import { LexplusNewsDetailDto } from '../../models/lexplus-news-detail-dto';

export interface NewsControllerCreateV1$Params {
      body: LexplusCreateNewsDto
}

export function newsControllerCreateV1(http: HttpClient, rootUrl: string, params: NewsControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusNewsDetailDto>> {
  const rb = new RequestBuilder(rootUrl, newsControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusNewsDetailDto>;
    })
  );
}

newsControllerCreateV1.PATH = '/v1/news';
